module.exports = __webpack_public_path__ + "img/competitors-icon.70fcadd8.svg";